import { render, staticRenderFns } from "./MoreFilters.vue?vue&type=template&id=72c542da&scoped=true"
import script from "./MoreFilters.vue?vue&type=script&lang=js"
export * from "./MoreFilters.vue?vue&type=script&lang=js"
import style0 from "./MoreFilters.vue?vue&type=style&index=0&id=72c542da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c542da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
